// https://stackoverflow.com/questions/29453717/closest-divisible-integer
export function toDiv(value: number, divisor: number, withUpsale = false) {
  if (!withUpsale) {
    return Math.floor(value / divisor) * divisor;
  }

  const c1 = value - (value % divisor);
  const c2 = value + divisor - (value % divisor);
  if (value - c1 > c2 - value) {
    return c2;
  }

  return c1;
}
